import { useBilling, useLeague } from '../../../../hooks';
import './cashback.css';
import { DollarSign, TrendingUp, Shield, Info } from 'lucide-react';

export function Cashback() {
  const { currentSeason, bonus } = useLeague();
  const price = currentSeason?.value ?? 0;
  const { calculate } = useBilling();
  const { net } = calculate(price);
  const cashback = bonus.cashback;
  const maxGuaranteed: number = net * cashback.max;

  return (
    <>
      {cashback.has && (
        <>
          <div className="cashback-container">
            <div className="cashback-glow cashback-glow-left" />
            <div className="cashback-glow cashback-glow-right" />

            <div className="cashback-content">
              <div className="cashback-icon-wrapper">
                <DollarSign className="cashback-icon" />
              </div>
              <div className="cashback-text">
                <h2 className="cashback-title">Sistema de Cashback Imperial</h2>
                <p className="cashback-description">
                  Incluso si no ganas ningún premio, tienes la posibilidad de
                  recuperar parte de tu inversión. Podrás recibir entre{' '}
                  <span className="cashback-highlight-min">
                    {cashback.min * 100}%
                  </span>{' '}
                  y{' '}
                  <span className="cashback-highlight-max">
                    {cashback.max * 100}%
                  </span>{' '}
                  del precio base de tu tarjeta.
                </p>

                <div className="cashback-info-box">
                  <div className="cashback-info-content">
                    <Info className="cashback-info-icon" />
                    <div>
                      <h3 className="cashback-info-title">
                        ¿Cómo funciona el Cashback?
                      </h3>
                      <p className="cashback-info-text">
                        Al finalizar la temporada, si no obtienes ninguno de los
                        botines principales, podrías recibir un porcentaje del{' '}
                        <strong className="cashback-strong">precio base</strong>{' '}
                        de tu compra (sin IVA ni gastos de gestión) como
                        retorno. El porcentaje varía según la cantidad de
                        participantes.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="cashback-features">
                  <div className="cashback-feature">
                    <div className="cashback-feature-icon-wrapper">
                      <Shield className="cashback-feature-icon" />
                    </div>
                    <div className="cashback-feature-text">
                      <div className="cashback-feature-label">
                        Protección Garantizada
                      </div>
                      <div className="cashback-feature-value">
                        De hasta €{maxGuaranteed.toFixed(2)}
                      </div>
                    </div>
                  </div>
                  <div className="cashback-feature">
                    <div className="cashback-feature-icon-wrapper">
                      <TrendingUp className="cashback-feature-icon" />
                    </div>
                    <div className="cashback-feature-text">
                      <div className="cashback-feature-label">
                        Devolución Automática
                      </div>
                      <div className="cashback-feature-value">
                        {cashback.min * 100}% - {cashback.max * 100}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
